<template>
  <div class="card">
    <slot>
      <div>
        暂无内容
      </div>
    </slot>
    <hideBox :item="item" :type="type"></hideBox>
    <!-- 劳务公司的按钮 -->
    <hideBoxs v-if="isLaborCompany" :item="item" :type="type"></hideBoxs>
  </div>
</template>

<script>
export default {
  name: "card",
  components: {
    hideBox: () => import("@/components/hideBox/hideBox"),
    hideBoxs: () => import("@/components/hideBoxLaborCompany/hideBox"),
  },
  props: {
    item: {
      type: Object
    },
    type: {
      type: Number // 1 工队 2 工程 3 工人 4 临时用工 5 工种报价 6劳务用工
    },
    isLaborCompany: {
      type: Object,
      default:false 
    },
  },
}
</script>

<style lang="scss" scoped>
  .card{
    border: 1px solid #e4e7ed;
    background: #fff;
    min-height: 100px;
    margin-top: 20px;
    transition: transform 0.4s ease-in-out;
    font-size: 14px;
    .hideBox{
      display: none;
    }
    .hideBoxs{
      display: none;
    }
    &:hover{
      transform: translateY(-20px);
      border: 1px solid #b79255;
      .hideBox{
        display:flex;
      }
      .hideBoxs{
        display:flex;
      }
    }
  }
</style>
